import { useCallback } from 'react';
import { useRelayEnvironment } from 'react-relay';
import { fetchQuery } from 'relay-runtime';

import { refundHistoryIdQuery } from '@/__generated__/refundHistoryIdQuery.graphql';
import { indisRefundHistoryIdQuery } from '@/graphql/query/common/refund-history-id';

export const useRefundHistoryId = () => {
  const relayEnv = useRelayEnvironment();

  const getRefundHistoryId = useCallback(async () => {
    return await fetchQuery<refundHistoryIdQuery>(relayEnv, indisRefundHistoryIdQuery, {})
      .toPromise()
      .then((res) => res?.getRefundHistoryId.refundHistoryId || '')
      .catch(() => '');
  }, [relayEnv]);

  return { getRefundHistoryId };
};
